var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeaderMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 14.6396C20.6977 14.9133 19.7404 15.0604 18.7487 15.0604C13.3307 15.0604 8.93856 10.6682 8.93856 5.25024C8.93856 4.25902 9.08557 3.30214 9.35897 2.40021C5.33153 3.62159 2.40002 7.36325 2.40002 11.7896C2.40002 17.2076 6.79218 21.5998 12.2102 21.5998C16.637 21.5998 20.3789 18.6677 21.5999 14.6396Z",
    stroke: "#42485A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeaderMoon);
export default __webpack_public_path__ + "static/media/Icon-Header-moon.e461e04fff10c18688e9e76a8d7cb57b.svg";
export { ForwardRef as ReactComponent };